import React from 'react'

import type { SelectProps } from '@fourthwall/components'
import { Select } from '@fourthwall/components'
import { timezones } from '@fourthwall/utils/dist/timezone'

const timezoneOptions = timezones.map((timezone) => ({
  label: timezone.label,
  value: timezone.name,
}))

type TimezoneSelectProps = SelectProps

export const TimezoneSelect = (props: TimezoneSelectProps) => {
  return <Select {...props} options={timezoneOptions} />
}
